import React from "react";
import { Tabs, Tab } from "@mui/material";

const CustomTabs = ({ activeTab, setActiveTab, tabLabels }) => {
  return (
    <Tabs
      value={activeTab}
      onChange={(e, newValue) => setActiveTab(newValue)}
      textColor="inherit"
      indicatorColor="secondary"
    >
      {tabLabels.map((label, index) => (
        <Tab key={index} label={label} />
      ))}
    </Tabs>
  );
};

export default CustomTabs;
